import React, { createContext, useState, useEffect, useContext } from 'react'
import jwt from 'jsonwebtoken'

const AuthContext = createContext();

function getCookie(name) {
    let cookie = {};
    document.cookie.split(';').forEach(function(el) {
        let [k,v] = el.split('=');
        cookie[k.trim()] = v;
    })
    return cookie[name];
}

const passwordModel = {
    password: "",
    npassword: "",
    vnpassword: ""
}

const userModel = {
    id: "",
    email: "",
    avatarPreview: "",
    avatar: "",
    street: "",
    city: "",
    phone: "",
}

export const AuthProvider = ({children}) => {
    const [userProfile, setUserProfile] = useState(userModel);
    const [password, setPassword] = useState(passwordModel);

    useEffect(() => {
        refreshToken()
    }, [])

    const fillUserProfile = (token) => {
        const { id, email, userinfo } = token;

        setUserProfile(state => {
            return {...state,
                id: id,
                email: email,
                avatar: (userinfo && userinfo.avatar) || "",
                street: (userinfo && userinfo.street) || "",
                city: (userinfo && userinfo.city) || "",
                phone: (userinfo && userinfo.phone) || "",
            }
        });
    }

    const refreshToken = () => {
        if( isLoggedIn() ) {
            const token = jwt.decode( getCookie("apptoken") );
            fillUserProfile(token);
        }
    }

    const isLoggedIn = () => {
        if( getCookie("apptoken") && (Date.now() >= jwt.decode( getCookie("apptoken") * 1000 )) ) {
            return true;
        } else {
            return false;
        }
    }

    const logoutUser = (history) => {
        document.cookie.split(";").forEach(function(c) { document.cookie = c.replace(/^ +/, "").replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/"); });
        history.push('/connect');
        setUserProfile(user => user = userModel)
    }

    const manageLoginForm = (fields) => {
        if(!fields.email || !fields.password) {
            return;
        }
        const headers = new Headers({
            "Content-type": "application/json",
            "Accept": "application/json"
        })
        const init = {
            method: "POST",
            headers: headers,
            body: JSON.stringify(fields)
        }
        fetch('/login', init)
        .then(res => res.json())
        .then(data => {
            const token = jwt.decode(data.token);
            fillUserProfile(token);
        })
    }

    const manageSignUpForm = (fields) => {
        const headers = new Headers({
            "Content-type": "application/json",
            "Accept": "application/json"
        })
        const init = {
            method: "POST",
            body: JSON.stringify(fields),
            headers: headers
        }
        fetch('/signup', init)
        .then(res => res.json())
        .then(data => console.log(data))
    }

    const handleProfileFields = (e, file = false) => {

        const name = file ? "avatar" : e.name;
        const value = file ? e.target.files[0] : e.value;
        
        if(file) {
            const reader = new FileReader();
            reader.addEventListener("load", function () {
              setUserProfile(state => {
                return {
                    ...state,
                    avatarPreview: reader.result,
                    avatar: value
                }
            })
            }, false);
          
            if (value) {
              reader.readAsDataURL(value);
            }
        } else {
            setUserProfile((state) => {
              return { ...state, [name]: value };
            });
        }

    };

    const handleUpdateProfile = (e) => {
        e.preventDefault();
    
        const formData = new FormData();
        for (const userField in userProfile) {
          formData.append(userField, userProfile[userField]);
        }
    
        const settings = {
          method: "POST",
          body: formData,
        };
    
        fetch("/profile/update", settings)
          .then((res) => res.json())
          .then((data) => {
            refreshToken();
          });
    };

    const managePasswordForm = (e) => {
        if(e === "reset") {
            setPassword(state => {
                return { ...state, ...passwordModel}
            })
        } else {
            setPassword(state => {
                return {...state,  [e.name]: e.value}
            })
        }
    }

    const submitPassword = () => {
        return fetch('/password', {
            method: "POST",
            body: JSON.stringify(password),
            headers: {
                "Content-Type": "application/json"
            }
        })
        .then(r => r.json())
        
    }

    
    const value = {
        userProfile,
        handleProfileFields,
        handleUpdateProfile,
        logoutUser,
        isLoggedIn,
        manageLoginForm,
        manageSignUpForm,
        refreshToken,
        setUserProfile,
        managePasswordForm,
        submitPassword
    }
    return (
        <AuthContext.Provider value={value}>
            {children}
        </AuthContext.Provider>
    )
}

export default AuthContext;
